import type { RouteRecordRaw } from 'vue-router';
import { BOOK_APPOINTMENT_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const createAppointmentRoutes: RouteRecordRaw = {
  path: '/book-appointment/create',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: BOOK_APPOINTMENT_ROUTE_NAME.CREATE_APPOINTMENT, path: '', component: () => import('./CreateAppointment.vue') },
  ],
};
